(function () {
    'use strict';

    angular.module("imApp").factory("stockPlaceDelTimeService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 783,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 784,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
